(() => {
  const BREAKPOINT = 1440;
  const ACTIVE = 'is-active';

  const init = (root) => {
    if (root.dataset.dotSliderReady === 'true') return;
    root.dataset.dotSliderReady = 'true';

    const track = root.querySelector('.dot-slider__track');
    const slides = Array.from(root.querySelectorAll('.dot-slider__slide'));
    if (!track || !slides.length) return;

    const prev = root.querySelector('.dot-slider__nav-prev');
    const next = root.querySelector('.dot-slider__nav-next');
    let index = 0;

    const isExpanded = () => window.innerWidth >= BREAKPOINT;

    const HEIGHT_SLACK = 20;

    const lockHeight = () => {
      track.style.minHeight = '';
      if (!isExpanded()) return;
      const tallest = slides.reduce((max, slide) => Math.max(max, slide.offsetHeight), 0);
      if (tallest) track.style.minHeight = `${tallest + HEIGHT_SLACK}px`;
    };

    const render = () => {
      slides.forEach((slide, i) => slide.classList.toggle(ACTIVE, i === index));
    };

    const goTo = (i) => {
      index = Math.max(0, Math.min(slides.length - 1, i));
      render();
    };

    slides.forEach((slide, i) => {
      slide.addEventListener('click', () => {
        if (isExpanded()) goTo(i);
      });
    });

    prev?.addEventListener('click', () => {
      if (isExpanded()) goTo(index - 1);
    });

    next?.addEventListener('click', () => {
      if (isExpanded()) goTo(index + 1);
    });

    root.querySelectorAll('.dot-slider__media img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', lockHeight, { once: true });
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(lockHeight, 150);
    });

    window.addEventListener('load', lockHeight);

    render();
    lockHeight();
  };

  const initAll = () => document.querySelectorAll('.dot-slider').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
